import styled from 'styled-components'

export const MaxWidth = styled.div`
  max-width: 1300px;
  width: 100%;
  margin: 0 auto;
`
